var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-config-container" }, [
    _c(
      "div",
      { staticClass: "list-container" },
      [
        _c(
          "el-form",
          {
            staticClass: "compact-search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "选择奖励", clearable: "" },
                    model: {
                      value: _vm.searchForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "status", $$v)
                      },
                      expression: "searchForm.status",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "待完成", value: "todo" },
                    }),
                    _vm._v(" "),
                    _c("el-option", {
                      attrs: { label: "可领取", value: "ready" },
                    }),
                    _vm._v(" "),
                    _c("el-option", {
                      attrs: { label: "已领取", value: "done" },
                    }),
                    _vm._v(" "),
                    _c("el-option", {
                      attrs: { label: "领取中", value: "loading" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": "YYYY-MM-dd HH:mm:ss",
                  },
                  on: { change: _vm.changeTime },
                  model: {
                    value: _vm.searchForm.times,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "times", $$v)
                    },
                    expression: "searchForm.times",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "form-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.fetchList } },
                  [_vm._v("查询")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              "max-height": _vm.maxHeight,
              data: _vm.tableData,
              stripe: "",
              border: "",
              "element-loading-text": "数据加载中...",
              "element-loading-spinner": "el-icon-loading",
            },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", align: "center", width: "60" },
            }),
            _vm._v(" "),
            _c(
              "el-table-column",
              { attrs: { prop: "title", label: "用户信息", align: "center" } },
              [
                [
                  _c("div", [_vm._v("gaga用户 5609022")]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                           17832506738 银卡\n                       "
                    ),
                  ]),
                ],
              ],
              2
            ),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "领取奖励内容",
                prop: "expandFail",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "领取时间", prop: "actTime", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "参与活动名称",
                prop: "expandFail",
                align: "center",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.searchForm.limit,
                total: _vm.searchForm.total,
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }